"use client";

import dynamic from "next/dynamic";

export const TestnetBannerDynamic = dynamic(
  () => import("@/components/shared/banners/testnet-banner"),
  {
    ssr: false,
  },
);
